import { IS_REDESIGN_ENABLED } from '../../constants/experiments';
import { IExperiment } from '../../types/experiments';
import { IApplicationState } from '../../types/redux';
import { getExperimentGroup } from '../../utils/experiments';
import { selectExperiments } from '../experiments';

export const isRedesign = (experiments: IExperiment[]): boolean =>
  getExperimentGroup(experiments, IS_REDESIGN_ENABLED) === 'B';

export const selectIsRedesign = (state: IApplicationState): boolean => {
  const experiments = selectExperiments(state);

  return isRedesign(experiments);
};
